import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { customerSearch } from '../../../modules/customer';
import SimpleTable from '../../components/SimpleTable';

const columns = [
    { title: 'Id', dataIndex: 'id', key: 'id', width: 110},
    { title: 'Partner Kundenummer', dataIndex: 'externalReference', key: 'externalReference', width: 150},
    { title: 'Fornavn', dataIndex: 'firstName', key: 'firstName', width: 150},
    { title: 'Etternavn', dataIndex: 'lastName', key: 'lastName', width: 200},
    { title: 'E-post', dataIndex: 'email', key: 'email'},
    { title: 'Telefon', dataIndex: 'mobilePhone', key: 'mobilePhone', width: 150 },
    { title: 'Fødselsdato', dataIndex: 'birthDate', key: 'birthDate', width: 180},
    { title: 'Poststed', dataIndex: 'city', key: 'city', width: 170},
    { title: 'Gate', dataIndex: 'street', key: 'street', width: 100},
    { title: 'Postnr.', dataIndex: 'zip', key: 'zip', width: 60 },
    { title: 'Type', dataIndex: 'type', key: 'type', width: 60 },
    { title: 'Class', dataIndex: 'class', key: 'class', width: 60 },
    ];

const CustomerSearchResults = ({searchResults, isLoading, isVisible, searchResultsRowClickHandler}) => (
       isVisible && 
        <div>
            <span className="alert alert-warning">Vi viser bare tjue poster. For å se mer legge til flere søkekriterier</span>
            <SimpleTable
                columns={columns} 
                data={searchResults}
                onRowClick={searchResultsRowClickHandler}      
                isLoading = {isLoading}   
            />
        </div>
);

const mapStateToProps = createStructuredSelector({    
    isLoading: customerSearch.selectors.isLoading,
    isVisible: customerSearch.selectors.isVisible,
});

const mapDispatchToProps = {
    searchResultsRowClickHandler: (record, index, event) => push(`/customer/${record.id}`),
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerSearchResults);
